/* Champs de quantite (surface m², ml, lots, pieces, calculateur de surface) : au clic / focus, la valeur
   est entierement selectionnee -> taper "27" remplace directement "1". Delegation sur document : marche
   aussi pour les champs (re)rendus en JS. Aucune logique de calcul touchee. */
(function () {
  if (window.__mpnQtySelectAll) return; window.__mpnQtySelectAll = true;
  var SEL = 'quantity-calculator input.volume__input, quantity-calculator input.quantity__input, ' +
            'input.volume__input, .product-form__quantity input.quantity__input, .msc-panel input';
  var EXCL = 'cart-drawer, cart-items, cart-drawer-items, .cart-drawer, .quick-order-list';
  function ok(el) {
    return el && el.matches && el.matches(SEL) && !el.readOnly && !el.disabled && !(el.closest && el.closest(EXCL));
  }
  function selAll(el) {
    try { el.select(); } catch (e) {
      try { el.setSelectionRange(0, String(el.value).length); } catch (e2) {}
    }
  }
  var pending = null;
  document.addEventListener('pointerdown', function (e) {
    var el = e.target;
    pending = (ok(el) && document.activeElement !== el) ? el : null;
  }, true);
  function up(e) {
    var el = e.target;
    if (pending && el === pending) {
      if (e.cancelable) e.preventDefault();
      selAll(el);
    }
    if (e.type === 'mouseup' || e.pointerType !== 'mouse') pending = null;
  }
  document.addEventListener('pointerup', up, true);
  document.addEventListener('mouseup', up, true);
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!ok(el)) return;
    selAll(el);
    setTimeout(function () { if (document.activeElement === el) selAll(el); }, 0);
  }, true);
})();
